export const LOCATION_LIST = [
    'Asheville', 'Weaverville', 'Black Mountain', 'Hendersonville', 'Arden', 'Mills River',
    'Swannanoa', 'Brevard', 'Marshall', 'Waynesville', 'Lake Lure', 'Fletcher', 'Leicester',
    'Canton', 'Hot Springs', 'Burnsville', 'Etowah', 'Fairview', 'Old Fort',
]